import {ContentData} from './contentdata';
export class AddContent {

  public file: string;
  public media: any;
  public media_id: string;
  public media_url: string;
  public media_type: string;
  public media_mime_type: string;
  public media_name: string;
  public link_url: string;
  public title: string;
  public description: string;
  public subject_id: string;
  public topic_id: string;
  public start_year_id: string;
  public end_year_id: string;
  public duration: number;
  public source_id: string;
  public language_id: string;
  public tags: string[] = [];
  public status: string;
  published_to: any;
}

export class PublishTo {
  all: boolean;
  projects: string[];
  school:boolean;
  self:boolean;
}